export default "__VITE_ASSET__d691d0be__"